module.exports = __webpack_public_path__ + "static/logo-02b1abcbcdd1a8e15a3805e49ab73d9b.png";